/**
 * Contagem regressiva até o início da live, no lugar da capa do post do blog. O
 * backend manda o início em ISO-8601 com o fuso (`liveCountdown`); a conta é entre
 * dois instantes, então o fuso do navegador não importa.
 *
 * O modelo mostra dias, horas e minutos, sem segundos. Os minutos arredondam para
 * cima: faltando 30 segundos, mostra 00:00:01, e a contagem nunca fica parada em
 * zeros antes do início. No início, ou depois dele, volta null e a capa reaparece.
 *
 * Também volta null sem data, com data inválida ou com 100 dias ou mais: o modelo
 * tem dois dígitos para os dias.
 */
export type PartesDaContagem = { dias: number; horas: number; minutos: number };

const MINUTO = 60 * 1000;
const MINUTOS_POR_DIA = 24 * 60;

export function partesDaContagem(
  inicio: string | null | undefined,
  agora: number
): PartesDaContagem | null {
  if (!inicio) {
    return null;
  }

  const alvo = Date.parse(inicio);
  if (isNaN(alvo) || alvo <= agora) {
    return null;
  }

  const minutos = Math.ceil((alvo - agora) / MINUTO);
  const dias = Math.floor(minutos / MINUTOS_POR_DIA);
  if (dias > 99) {
    return null;
  }

  return {
    dias,
    horas: Math.floor((minutos % MINUTOS_POR_DIA) / 60),
    minutos: minutos % 60,
  };
}

/** Um dígito por cartão: 1 vira ["0", "1"]. */
export function doisDigitos(valor: number): [string, string] {
  const texto = String(valor).padStart(2, "0");
  return [texto[0], texto[1]];
}
